export const TODO_LIST_VISIBILITY = 'TODO_LIST_VISIBILITY';
